import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { Link } from 'gatsby';
var SubListGroups = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SubListGroups, _React$Component);
  function SubListGroups() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = SubListGroups.prototype;
  _proto.filter = function filter(kind) {
    return this.props.items.filter(function (item) {
      return item.kind === kind;
    });
  };
  _proto.getSubListGroupComponent = function getSubListGroupComponent(title, items) {
    var selectedId = this.props.selectedId;
    if (items && items.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: "subnav-group"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "title"
      }, title), /*#__PURE__*/React.createElement("ul", null, items.map(function (item, index) {
        var pid = item.pid,
          name = item.name;
        return /*#__PURE__*/React.createElement("li", {
          key: "nav-item-" + index
        }, /*#__PURE__*/React.createElement("p", {
          className: "nav-item" + (selectedId === pid ? ' selected' : '')
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/" + pid,
          className: "ellipsis"
        }, /*#__PURE__*/React.createElement("span", null, name))));
      })));
    }
    return null;
  };
  _proto.render = function render() {
    var opened = this.props.opened;
    return /*#__PURE__*/React.createElement("div", {
      className: opened ? 'show' : 'hide'
    }, this.getSubListGroupComponent('EXTENDS', this.filter('augment')), this.getSubListGroupComponent('MIXES', this.filter('mix')), this.getSubListGroupComponent('STATIC PROPERTIES', this.filter('static-property')), this.getSubListGroupComponent('STATIC METHODS', this.filter('static-method')), this.getSubListGroupComponent('INSTANCE METHODS', this.filter('instance-method')), this.getSubListGroupComponent('EVENTS', this.filter('event')));
  };
  return SubListGroups;
}(React.Component);
export default SubListGroups;